module.exports = __webpack_public_path__ + "static/fonts/NeueAugenblick-Medium.2301eba6.woff";